// Centralized localStorage helpers for Brahmastra AI
const KEYS = {
  CHATS: 'brahmastra.chats.v1',
  ACTIVE_CHAT: 'brahmastra.activeChat.v1',
  NOTES: 'brahmastra.notes.v1',
  GAMI: 'brahmastra.gami.v1',
  THEME: 'brahmastra.theme.v1',
  GURU: 'brahmastra.guru.v1',
  PRIME: 'brahmastra.prime.v1',
};

export const storage = {
  KEYS,
  get(key, fallback) {
    try {
      const v = localStorage.getItem(key);
      return v ? JSON.parse(v) : fallback;
    } catch {
      return fallback;
    }
  },
  set(key, value) {
    try {
      localStorage.setItem(key, JSON.stringify(value));
    } catch {
      // ignore
    }
  },
  remove(key) {
    try { localStorage.removeItem(key); } catch { /* noop */ }
  }
};

export const XP_PER_MESSAGE = 8;
export const XP_PER_QUIZ_CORRECT = 15;
export const XP_PER_NOTE = 5;

export function computeLevel(xp) {
  // simple curve: level n needs n*100 xp
  let level = 1;
  let need = 100;
  let remaining = xp;
  while (remaining >= need) {
    remaining -= need;
    level += 1;
    need = level * 100;
  }
  return { level, currentXP: remaining, nextLevelXP: need };
}

export function addXP(amount) {
  const g = storage.get(KEYS.GAMI, { xp: 0 });
  g.xp = (g.xp || 0) + amount;
  storage.set(KEYS.GAMI, g);
  return g.xp;
}
